document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-pd-wrap]').forEach(function (wrap) {
    var content = wrap.querySelector('[data-pd-content]');
    var section = wrap.closest('.pd');
    var toggle = section ? section.querySelector('[data-pd-toggle]') : null;

    if (!toggle || !content) return;

    var label = toggle.querySelector('[data-pd-toggle-label]');
    var moreText = toggle.getAttribute('data-more-label') || label.textContent;
    var lessText = toggle.getAttribute('data-less-label');

    // Als de content sowieso al binnen de ingeklapte hoogte past: geen knop nodig
    if (content.scrollHeight <= wrap.clientHeight + 4) {
      wrap.classList.add('no-clamp');
      toggle.classList.add('is-hidden');
      return;
    }

    toggle.addEventListener('click', function () {
      var expanded = wrap.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (label) {
        label.textContent = expanded ? lessText : moreText;
      }
    });
  });
});
